import { unref, computed } from 'vue';
import { FORM_STATES } from '../constants/constants';
export const useFormState = (formState) => {
	const isForm = computed(() => unref(formState) === FORM_STATES.FORM);
	const isSent = computed(() => unref(formState) === FORM_STATES.SENT);
	const isModify = computed(() => unref(formState) === FORM_STATES.MODIFY);
	const isSuccess = computed(() => unref(formState) === FORM_STATES.SUCCESS);
	const isGwbError = computed(() => unref(formState) === FORM_STATES.GWB_ERROR);
	const isNotSubscribedError = computed(() => unref(formState) === FORM_STATES.NOT_SUBSCRIBED_ERROR);
	const isAlreadySubscribedError = computed(() => unref(formState) === FORM_STATES.ALREADY_SUBSCRIBED_ERROR);
	const isTechnicalError = computed(() => unref(formState) === FORM_STATES.TECHNICAL_ERROR);
	const isError = computed(
		() => isGwbError.value || isAlreadySubscribedError.value || isNotSubscribedError.value || isTechnicalError.value
	);
	return {
		isForm,
		isSent,
		isModify,
		isSuccess,
		isGwbError,
		isAlreadySubscribedError,
		isNotSubscribedError,
		isTechnicalError,
		isError
	};
};
